import { createApp } from 'vue'

/*
The pre-migration import order, which sets the CSS order: global components, then the Element Plus theme (the first
plugin), then the screens the router pulls in, so screen styles still win ties with the theme
*/
import registerGlobalComponents from '@/components'
import installPlugins from '@/plugins'
import registerGlobalDirectives from '@/directives'
import app from './app.vue'
import pinia from '@/services/store/store'
import router from '@/services/router/router'

import 'quill/dist/quill.snow.css'
import 'quill-table-better/dist/quill-table-better.css'
import './assets/styles/main.scss'

declare global {
  interface Window {
    Appcues?: {
      page(): void
      identify(userId: string, properties: object): void
      anonymous(): void
    }
    dataLayer: object[]
  }
}

const vueApp = createApp(app)
// Log errors and carry on, as Vue 2 did and Vue 3 does in production; in development Vue 3 rethrows them instead,
// which leaves a page half-rendered over a template error that production users would never notice
vueApp.config.errorHandler = (err, instance, info) => console.error(err, info)

vueApp.use(pinia)
vueApp.use(router)
installPlugins(vueApp)
registerGlobalComponents(vueApp)
registerGlobalDirectives(vueApp)

// Call `Appcues.page()` once the URL has updated
router.afterEach((to, from, failure) => {
  if (!failure) {
    window.Appcues?.page()
  }
})

vueApp.mount('#app')
